import { components, useApi } from "@appretio/api";
import { useMutation } from "@tanstack/react-query";

type ExportCubeInput = components["schemas"]["ExportCubeInput"];

export function useExportCube() {
  const apiClient = useApi();

  return useMutation({
    mutationFn: async (input: ExportCubeInput) => {
      const response = await apiClient.POST("/v2/forecast/exports/start", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in export cube response");
      }
      return response.data.result;
    },
    meta: {
      errorMessage: "Failed to start export"
    }
  });
}
